export const formatTimestamp = (date = new Date()) => {

    const input = (date instanceof Date) ? date : new Date(date);
    const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Mexico_City',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });

    const parts = dtf.formatToParts(input).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
    }, {});

    const day = parts.day;
    const month = parts.month;
    const year = parts.year;
    const hours = parts.hour; // already zero-padded due to options
    const minutes = parts.minute;
    const seconds = parts.second;
    const ampm = parts.dayPeriod || '';

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}${ampm}`;
};

/**
 * Convierte una fecha en formato DD-MM-YYYY o DD-MM-YYYY HH:MM:SS 
 * a formato YYYY-MM-DD para inputs tipo date
 * @param {string} dateStr - Fecha en formato DD-MM-YYYY
 * @returns {string} Fecha en formato YYYY-MM-DD
 */
export const toInputDate = (dateStr) => {
    if (!dateStr) return '';
    const datePart = dateStr.split(' ')[0]; // "DD-MM-YYYY HH:MM..." -> "DD-MM-YYYY"
    if (datePart.match(/^\d{2}-\d{2}-\d{4}$/)) {
        const [day, month, year] = datePart.split('-');
        return `${year}-${month}-${day}`; // "YYYY-MM-DD"
    }
    return datePart;
};

/**
 * Convierte una fecha a formato YYYY-MM-DD para enviar a la API
 * Acepta formatos: YYYY-MM-DD (pasa directo) o DD-MM-YYYY (convierte)
 * @param {string} dateStr - Fecha en varios formatos
 * @returns {string|null} Fecha en formato YYYY-MM-DD o null
 */
export const toAPIDate = (dateStr) => {
    if (!dateStr) return null;
    // Si ya está en formato YYYY-MM-DD, retornar directamente
    if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) return dateStr;
    // Si está en formato DD-MM-YYYY, convertir
    if (dateStr.match(/^\d{2}-\d{2}-\d{4}/)) {
        const [day, month, year] = dateStr.split(/[\s-]/)[0].split('-');
        return `${year}-${month}-${day}`;
    }
    return dateStr;
};